import ErrorResponse from '@/trials/domain/objects/errorResponse';

/**
 * エラーダイアログ用のデータを保持するクラス
 */
export default class ErrorDialogData {
    /**
     * タイトルで使用するキー\
     * i18nで設定されているキーの形式
     */
    public title: string = 'error.title';

    /**
     * メッセージで使用するキー\
     * i18nで設定されているキーの形式
     */
    public messageKey: string;

    /**
     * ダイアログを閉じた際にリロードが必要か
     */
    public needCloseAndReload: boolean = false;

    /**
     * ダイアログを閉じた際にトークンのクリアが必要か
     */
    public needClearToken: boolean = false;

    /**
     * ダイアログを閉じた際に初期化が必要か
     */
    public needInit: boolean = false;

    /**
     * APIのレスポンスエラーの場合、レスポンスを保持
     */
    public errResponse: ErrorResponse | null;

    /**
     * コンストラクタ
     * @param key メッセージ用キー
     * @param response APIレスポンス
     */
    constructor(key: string = 'error.message.default', response: ErrorResponse | null = null) {
        this.messageKey = key;
        this.errResponse = response;
    }
}
